import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bee0737&scoped=true&"
import script from "./index.js?vue&type=script&lang=ts&"
export * from "./index.js?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=2bee0737&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee0737",
  null
  
)

export default component.exports